import { createSlice } from '@reduxjs/toolkit';

export const userSlice = createSlice({
  name: 'user',
  initialState: {
    user:
      (localStorage.getItem('user') &&
        JSON.parse(localStorage.getItem('user'))) ||
      {},
    token: localStorage.getItem('token') || null,
    type: null,
  },
  reducers: {
    setUser: (state, action) => {
      localStorage.setItem('user', JSON.stringify(action.payload));
      state.user = action.payload;
    },
    setType: (state, action) => {
      state.type = action.payload;
    },
    fetchUser: (state, action) => {},
    setToken: (state, action) => {
      localStorage.setItem('token', action.payload);
      state.token = action.payload;
    },
    setTwoFA: (state, action) => {
      localStorage.setItem('twoFA', action.payload);
      state.twoFA = action.payload;
    },
    userLogout: (state, action) => {
      localStorage.setItem('token', null);
      localStorage.setItem('user', null);
      localStorage.setItem('twoFA', null);
      localStorage.removeItem('token');
      localStorage.removeItem('user');
      localStorage.removeItem('twoFA');
      state.token = null;
      state.user = null;
      state.type = null;
      state.twoFA = null;
    },
  },
});

export const currentUser = (state) => state.user.user;
export const currentType = (state) => state.user.type;
export const currentToken = (state) => state.user.token;
export const isCompany = (state) => state?.user?.user?.user?.type === 1;
export const {
  setUser,
  setType,
  fetchUser,
  setToken,
  setTwoFA,
  userLogout,
  uploadTeamID,
} = userSlice.actions;

export default userSlice.reducer;
